"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("vehicles").controller("VehiclesCtrl", Ctrl);

  /** @ngInject */
  function Ctrl($rootScope, $scope, $timeout, $controller, $confirm, TeaService, ModalService, AgGridService, ModelsService, CustomListsService, GroupsService, UsersService, CustomersService, VehiclesService, InsurerContractsService, SyncConfigsService, DamagesService, READ_SUMMARY_URL) {
    var _this2 = this;

    var vm = this;

    var pass = "ssssss";
    var encryptString = TeaService.encrypt("toto", pass);

    console.log("TEA1=", encryptString);
    console.log("TEA2=", TeaService.decrypt(encryptString, pass));

    $controller("VehiclesCtrl.bulk", {
      vm: vm
    });

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: VehiclesService,
      params: {
        editPage: "vehicles/vehicle"
      }
    });

    vm.ctrlName = "VehiclesCtrl";

    vm.activeTab = "actifs";

    setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ModelsService.onCustomerChange(vm.refresh, true);
              ModelsService.hotkeys($scope, "+", "Créer un nouveau véhicule", vm.create);

              vm.refresh();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    })), 0);

    vm.displayInfo = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(vehicle) {
        var _this = this;

        var source, damages, typeOfAccidentList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, forms;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                source = READ_SUMMARY_URL + "/";
                _context3.next = 3;
                return DamagesService.find({
                  filter: {
                    where: { vehicleId: "$" + vehicle._id },
                    order: { dateDamage: -1 },
                    fields: {
                      circumstance: true,
                      dateDamage: true,
                      name: true,
                      typeOfAccident: true,
                      driverId: true
                    }
                  }
                });

              case 3:
                damages = _context3.sent;
                _context3.next = 6;
                return CustomListsService.getSelectArray("typeOfAccidentV2");

              case 6:
                typeOfAccidentList = _context3.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 10;
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                  var damage, typeOfAccidentData;
                  return regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          damage = _step.value;
                          typeOfAccidentData = typeOfAccidentList.find(function (item) {
                            return damage.typeOfAccident === item.value;
                          });

                          if (typeOfAccidentData) {
                            damage.typeOfAccidentName = typeOfAccidentData.name.split(" (")[0];
                          } else {
                            damage.typeOfAccidentName = "N.C.";
                          }
                          _context2.next = 5;
                          return UsersService.getNameById(damage.driverId);

                        case 5:
                          damage.driverName = _context2.sent;

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop, _this);
                });
                _iterator = damages[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 18;
                  break;
                }

                return _context3.delegateYield(_loop(), "t0", 15);

              case 15:
                _iteratorNormalCompletion = true;
                _context3.next = 13;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t1 = _context3["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context3.prev = 27;

                if (!_didIteratorError) {
                  _context3.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context3.finish(27);

              case 31:
                return _context3.finish(24);

              case 32:
                forms = [{
                  name: "",
                  filters: ["Fiche"],
                  lines: [{
                    label: "Immatriculation",
                    value: vehicle.plateNumber
                  }, {
                    label: "Code interne",
                    value: vehicle.internalNumber || vehicle.label
                  }, {
                    label: "Type",
                    value: vehicle.typeName
                  }, {
                    label: "Contrat d'assurance",
                    value: vehicle.insurerContractName
                  }, {
                    label: "Date d'entrée",
                    value: vehicle.inDate ? moment(vehicle.inDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Date de sortie",
                    value: vehicle.outDate ? moment(vehicle.outDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Dernier relevé kms",
                    value: vehicle.mileage ? vehicle.mileage + " km" : ""
                  }, {
                    label: "Date du relevé",
                    value: vehicle.mileageDate ? moment(vehicle.mileageDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Conducteurs",
                    value: vehicle.driverNames
                  }, {
                    label: "Gestionnaire Parc",
                    value: vehicle.managerName
                  }, {
                    label: "Groupes",
                    value: vehicle.groupName
                  }, {
                    label: "Nom du loueur de voiture",
                    value: vehicle.carRentalName,
                    titleBefore: "Contrat de location"
                  }, {
                    label: "Date de restitution",
                    value: vehicle.carReturnDate ? moment(vehicle.carReturnDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Coût mensuel HT",
                    value: vehicle.carRentalCost ? vehicle.carRentalCost + " €" : ""
                  }, {
                    label: "Code postal",
                    value: vehicle.zipCode,
                    titleBefore: "Lieu de parking"
                  }, {
                    label: "Ville",
                    value: vehicle.city
                  }, {
                    label: "Marque",
                    value: vehicle.brand,
                    titleBefore: "Autre"
                  }, {
                    label: "Modèle",
                    value: vehicle.model
                  }, {
                    label: "Couleur",
                    value: vehicle.color
                  }, {
                    label: "Certificat qualité de l'air",
                    value: vehicle.critAirTypeName
                  }, {
                    label: "Commentaire",
                    value: vehicle.note
                  }, {
                    label: "Source d'énergie",
                    value: vehicle.engineTypeName,
                    titleBefore: "Equipements"
                  }, {
                    label: "Radar de recul",
                    value: vehicle.parkingAidRear ? "Oui" : "Non"
                  }, {
                    label: "Radar avant",
                    value: vehicle.parkingAidFront ? "Oui" : "Non"
                  }, {
                    label: "Caméra de recul",
                    value: vehicle.cameraRear ? "Oui" : "Non"
                  }, {
                    label: "Caméra avant",
                    value: vehicle.cameraFront ? "Oui" : "Non"
                  }, {
                    label: "Alerte de franchissement de ligne (LDW)",
                    value: vehicle.laneDepartureWarning ? "Oui" : "Non"
                  }, {
                    label: "Climatisation",
                    value: vehicle.airConditioning ? "Oui" : "Non"
                  }, {
                    label: "GPS",
                    value: vehicle.gps ? "Oui" : "Non"
                  }, {
                    label: "Régulateur de vitesse",
                    value: vehicle.cruiseControl ? "Oui" : "Non"
                  }, {
                    label: "Limiteur de vitesse",
                    value: vehicle.limitControl ? "Oui" : "Non"
                  }, {
                    label: "Régulateur de vitesse adaptatif (ACC)",
                    value: vehicle.adaptiveCruiseControl ? "Oui" : "Non"
                  }, {
                    label: "Pneus 4 saisons",
                    value: vehicle.allSeasonTire ? "Oui" : "Non"
                  }, {
                    label: "Date montage Pneus 4 saisons",
                    value: vehicle.allSeasonTireLastDate ? moment(vehicle.allSeasonTireLastDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Pneus hiver",
                    value: vehicle.winterTire ? "Oui" : "Non"
                  }, {
                    label: "Date montage Pneus hiver",
                    value: vehicle.winterTireLastDate ? moment(vehicle.winterTireLastDate).format("DD/MM/YYYY") : ""
                  }]
                }];

                if (damages && damages.length) {
                  forms.push({
                    name: damages.length + " sinistre(s)",
                    filters: ["Fiche"],
                    lines: [{
                      label: damages.length ? "<ul><li>" + damages.map(function (damage) {
                        return "<b>Numéro : </b>" + damage.name + "<br/>" + "<b>Date : </b>" + (damage.dateDamage ? moment(damage.dateDamage).format("DD/MM/YYYY") : "") + "<br/>" + "<b>Type : </b>" + damage.typeOfAccidentName + "<br/>" + "<b>Collaborateur : </b>" + damage.driverName + "<br/>" + "<b>Circonstances : </b>" + damage.circumstance + "<br/><br/>";
                      }).join("</li><li>") + "</li></ul>" : ""
                    }]
                  });
                }

                if (vehicle.docs && vehicle.docs.length) {
                  forms.push({
                    name: "Documents",
                    filters: ["Fiche", "Documents"],
                    lines: [{
                      label: "Documents associé au véhicule",
                      value: vehicle.docs
                    }]
                  });
                }

                _context3.next = 37;
                return VehiclesService.getHistory(vehicle._id);

              case 37:
                vehicle.history = _context3.sent;


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Fiche récapitulative",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  message: {
                    object: vehicle,
                    customerName: vehicle.customerName,
                    titleName: "Véhicule " + vehicle.plateNumber,
                    headerName: "Fiche récapitulative véhicule",
                    footerName: "Véhicule " + vehicle.plateNumber,
                    fileName: "Fiche r\xE9cap - V\xE9hicule " + vehicle.plateNumber,
                    filters: vehicle.docs && vehicle.docs.length ? ["Fiche", "Documents"] : ["Fiche"],
                    forms: forms
                  }
                }).then(function () {
                  console.log("close modal");
                }).catch(function (err) {
                  console.error("err", err);
                });

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this, [[10, 20, 24, 32], [25,, 27, 31]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    vm.openInsurerContracts = function () {
      ModalService.openComponent("insurer-contracts", { size: "lg" }).then(function () {
        vm.refresh();
        console.log("close modal");
      }).catch(function (err) {
        console.log("err", err);
      });
    };

    vm.refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if ($rootScope.$selectedCustomerId) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:

              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
              _context5.prev = 3;
              _context5.next = 6;
              return SyncConfigsService.findOne({
                filter: {
                  where: {
                    customerId: $rootScope.$selectedCustomerId.replace("$", "")
                  },
                  fields: { software: true }
                }
              });

            case 6:
              vm.syncConfig = _context5.sent;


              vm.setGridColumns();

              vm.rowsSelected = [];

              Promise.all([VehiclesService.load(["_id", "customerId", "internalNumber", "label", "plateNumber", "type", "brand", "model", "color", "engineType", "inDate", "outDate", "mileage", "mileageDate", "defaultManagerId", "_driverIds", "groupsId", "insurerContract", "carRentalName", "carRentalCost", "carReturnDate", "zipCode", "city", "critAirType", "parkingAidRear", "parkingAidFront", "cameraRear", "cameraFront", "cruiseControl", "limitControl", "adaptiveCruiseControl", "laneDepartureWarning", "airConditioning", "gps", "allSeasonTire", "allSeasonTireLastDate", "winterTire", "winterTireLastDate", "note", "docs", "importBy", "importDate", "updateDate", "updateBy", "creationDate", "lastUserModificationDate", "toCheck", "backgroundColor"])]).then(function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(values) {
                  var duplicatePlates, index, element, driverNames, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, driverId, driverName, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, groupId;

                  return regeneratorRuntime.wrap(function _callee3$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          vm.rawData = values[0];
                          vm.rawActive = [];
                          vm.rawDuplicate = [];
                          vm.rawToCheck = [];

                          duplicatePlates = {};
                          index = 0;

                        case 6:
                          if (!(index < vm.rawData.length)) {
                            _context4.next = 138;
                            break;
                          }

                          element = vm.rawData[index];


                          element.btInfo = {
                            text: '<i class="fa fa-file"></i> Fiche récap.',
                            color: "custom"
                          };

                          if (!(element.importBy && element.importBy.startsWith("$"))) {
                            _context4.next = 15;
                            break;
                          }

                          _context4.next = 12;
                          return UsersService.getNameById(element.importBy.replace("$", ""));

                        case 12:
                          _context4.t0 = _context4.sent;
                          _context4.next = 16;
                          break;

                        case 15:
                          _context4.t0 = element.importBy;

                        case 16:
                          element.importByName = _context4.t0;

                          if (element.importByName === "?.?" || element.importByName === "Supprimé") {
                            element.importByName = "LVR";
                          }

                          element.active = !element.outDate || new Date(element.outDate) >= new Date() ? true : false;
                          element.backgroundColor = !element.active ? "rgb(249, 161, 89, 0.5)" : element.backgroundColor; // custom-warning 50%

                          element.duplicate = false;

                          if (element.active) {
                            if (element.plateNumber && duplicatePlates[element.plateNumber]) {
                              element.duplicate = true;
                              if (duplicatePlates[element.plateNumber].length === 1) {
                                (function () {
                                  var previousVehicleId = duplicatePlates[element.plateNumber][0];
                                  if (vm.rawDuplicate.filter(function (row) {
                                    return row._id === previousVehicleId;
                                  }).length === 0) {
                                    var previousRow = vm.rawData.find(function (row) {
                                      return row._id === previousVehicleId;
                                    });
                                    vm.rawDuplicate.push(previousRow);
                                  }
                                })();
                              }
                              duplicatePlates[element.plateNumber].push(element._id);
                            } else if (element.plateNumber) {
                              duplicatePlates[element.plateNumber] = [element._id];
                            }
                          }

                          element.btEdit = {
                            text: '<i class="fa fa-edit"></i> Modifier',
                            color: "custom"
                          };

                          element.btDelete = {
                            text: '<i class="fa fa-trash"></i> Suppr.',
                            color: "custom-danger"
                          };

                          _context4.next = 26;
                          return InsurerContractsService.getNameById(element.insurerContract);

                        case 26:
                          element.insurerContractName = _context4.sent;
                          _context4.next = 29;
                          return CustomersService.getNameById(element.customerId);

                        case 29:
                          element.customerName = _context4.sent;
                          driverNames = [];

                          if (!element._driverIds) {
                            element._driverIds = [];
                          }
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context4.prev = 35;
                          _iterator2 = element._driverIds[Symbol.iterator]();

                        case 37:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context4.next = 46;
                            break;
                          }

                          driverId = _step2.value;
                          _context4.next = 41;
                          return UsersService.getNameById(driverId);

                        case 41:
                          driverName = _context4.sent;

                          driverNames.push(driverName);

                        case 43:
                          _iteratorNormalCompletion2 = true;
                          _context4.next = 37;
                          break;

                        case 46:
                          _context4.next = 52;
                          break;

                        case 48:
                          _context4.prev = 48;
                          _context4.t1 = _context4["catch"](35);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context4.t1;

                        case 52:
                          _context4.prev = 52;
                          _context4.prev = 53;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 55:
                          _context4.prev = 55;

                          if (!_didIteratorError2) {
                            _context4.next = 58;
                            break;
                          }

                          throw _iteratorError2;

                        case 58:
                          return _context4.finish(55);

                        case 59:
                          return _context4.finish(52);

                        case 60:

                          element.driverNames = driverNames.join(", ");

                          _context4.next = 63;
                          return UsersService.getNameById(element.defaultManagerId);

                        case 63:
                          element.managerName = _context4.sent;

                          if (!(element.groupsId && element.groupsId.length > 1)) {
                            _context4.next = 96;
                            break;
                          }

                          element.groupName = "";

                          _iteratorNormalCompletion3 = true;
                          _didIteratorError3 = false;
                          _iteratorError3 = undefined;
                          _context4.prev = 69;
                          _iterator3 = element.groupsId[Symbol.iterator]();

                        case 71:
                          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                            _context4.next = 80;
                            break;
                          }

                          groupId = _step3.value;

                          if (element.groupName) {
                            element.groupName += " | ";
                          }
                          _context4.next = 76;
                          return GroupsService.getNameById(groupId);

                        case 76:
                          element.groupName += _context4.sent;

                        case 77:
                          _iteratorNormalCompletion3 = true;
                          _context4.next = 71;
                          break;

                        case 80:
                          _context4.next = 86;
                          break;

                        case 82:
                          _context4.prev = 82;
                          _context4.t2 = _context4["catch"](69);
                          _didIteratorError3 = true;
                          _iteratorError3 = _context4.t2;

                        case 86:
                          _context4.prev = 86;
                          _context4.prev = 87;

                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }

                        case 89:
                          _context4.prev = 89;

                          if (!_didIteratorError3) {
                            _context4.next = 92;
                            break;
                          }

                          throw _iteratorError3;

                        case 92:
                          return _context4.finish(89);

                        case 93:
                          return _context4.finish(86);

                        case 94:
                          _context4.next = 104;
                          break;

                        case 96:
                          if (!element.groupsId) {
                            _context4.next = 102;
                            break;
                          }

                          _context4.next = 99;
                          return GroupsService.getNameById(element.groupsId[0]);

                        case 99:
                          _context4.t3 = _context4.sent;
                          _context4.next = 103;
                          break;

                        case 102:
                          _context4.t3 = "";

                        case 103:
                          element.groupName = _context4.t3;

                        case 104:

                          element.nbDocs = element.docs ? element.docs.length : 0;
                          element.registrationDoc = element.docs && element.docs.find(function (doc) {
                            return doc.what && doc.what.value == "V1";
                          }) ? true : false;

                          element.ndEquipment = 0;

                          element.ndEquipment += element.parkingAidRear === true ? 1 : 0;

                          element.ndEquipment += element.parkingAidFront === true ? 1 : 0;

                          element.ndEquipment += element.cameraRear === true ? 1 : 0;
                          element.ndEquipment += element.cameraFront === true ? 1 : 0;
                          element.ndEquipment += element.cruiseControl === true ? 1 : 0;
                          element.ndEquipment += element.limitControl === true ? 1 : 0;
                          element.ndEquipment += element.adaptiveCruiseControl === true ? 1 : 0;
                          element.ndEquipment += element.laneDepartureWarning === true ? 1 : 0;
                          element.ndEquipment += element.airConditioning === true ? 1 : 0;
                          element.ndEquipment += element.gps === true ? 1 : 0;
                          element.ndEquipment += element.allSeasonTire === true ? 1 : 0;
                          element.ndEquipment += element.winterTire === true ? 1 : 0;

                          if (!element.critAirType) {
                            _context4.next = 123;
                            break;
                          }

                          _context4.next = 122;
                          return CustomListsService.getNameByValue("typeVehicleCritAir", String(element.critAirType));

                        case 122:
                          element.critAirTypeName = _context4.sent;

                        case 123:
                          if (!element.type) {
                            _context4.next = 128;
                            break;
                          }

                          _context4.next = 126;
                          return CustomListsService.getNameByValue("typeVehicleV2", String(element.type));

                        case 126:
                          element.typeName = _context4.sent;

                          element.typeName = element.typeName ? element.typeName.split(" (")[0] : "";

                        case 128:
                          if (!element.engineType) {
                            _context4.next = 132;
                            break;
                          }

                          _context4.next = 131;
                          return CustomListsService.getNameByValue("typeVehicleEngineV2", String(element.engineType));

                        case 131:
                          element.engineTypeName = _context4.sent;

                        case 132:

                          if (element.active) {
                            vm.rawActive.push(element);
                          }
                          if (element.duplicate) {
                            vm.rawDuplicate.push(element);
                          }
                          if (element.toCheck) {
                            vm.rawToCheck.push(element);
                          }

                        case 135:
                          index++;
                          _context4.next = 6;
                          break;

                        case 138:

                          $timeout(function () {
                            vm.needToBeUpdate = true;
                          }, 0);
                          Notiflix.Loading.remove();

                        case 140:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee3, _this2, [[35, 48, 52, 60], [53,, 55, 59], [69, 82, 86, 94], [87,, 89, 93]]);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
              _context5.next = 16;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);

              console.log(_context5.t0);
              Notiflix.Loading.remove();

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4, _this2, [[3, 12]]);
    }));

    vm.executeAction = function () {
      console.log("action=", vm.action);

      $confirm({
        text: "Etes vous certain d'appliquer l'action " + vm.action + " sur les lignes sélectionnées?"
      }).then(function () {
        console.log("oui il veut", vm.rawData);

        for (var index = 0; index < vm.rawData.length; index++) {
          if (vm.rawData[index].checkbox) {
            console.log("s=", vm.rawData[index]);

            VehiclesService.deleteById(vm.rawData[index]._id).then(function () {});
          }
        }
      });

      vm.action = "Actions sur sélection";
    };

    vm.gridEvent = function (value) {
      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      } else if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 4;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Véhicules"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var writeResource = vm.isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.resource && $rootScope.$user.rights.resource.write && $rootScope.$user.rights.resource.write === true;
    var deleteResource = vm.isAdmin || $rootScope.$user.rights && $rootScope.$user.rights.resource && $rootScope.$user.rights.resource.delete && $rootScope.$user.rights.resource.delete === true;

    if (writeResource !== true) {
      vm.create = null;
      vm.edit = null;
    }

    vm.setGridColumns = function () {
      var infoColumnDefs = [];
      if (vm.syncConfig && vm.syncConfig.software) {
        infoColumnDefs.push(AgGridService.text("internalNumber", "ID " + vm.syncConfig.software));
      } else {
        infoColumnDefs.push(AgGridService.text("label", "Code interne"));
      }

      infoColumnDefs = [].concat(_toConsumableArray(infoColumnDefs), [AgGridService.bool("toCheck", "À vérifier"), AgGridService.bool("active", "Actif"), AgGridService.text("typeName", "Type", 100), AgGridService.text("brand", "Marque", 100, {
        columnGroupShow: "open"
      }), AgGridService.text("model", "Modèle", 100, {
        columnGroupShow: "open"
      }), AgGridService.text("driverNames", "Conducteurs"), AgGridService.text("managerName", "Gestionnaire Parc"), AgGridService.text("color", "Couleur", 100, {
        columnGroupShow: "open"
      }), AgGridService.text("engineTypeName", "Moteur", 100, {
        columnGroupShow: "open"
      })]);

      vm.columnDefs = [AgGridService.text("plateNumber", "Immatriculation", 120, {
        pinned: "left"
      }), AgGridService.text("groupName", "Groupes"), AgGridService.group("Infos", infoColumnDefs), AgGridService.group("Docs", [AgGridService.text("nbDocs", "Nb", 70), AgGridService.bool("registrationDoc", "Carte grise", 100, {
        columnGroupShow: "open"
      })]), AgGridService.text("insurerContractName", "Assurance", 100), AgGridService.text("carRentalName", "Nom du loueur"), AgGridService.text("carRentalCost", "Coût mensuel HT"), AgGridService.date("carReturnDate", "Date de restitution"), AgGridService.text("critAirTypeName", "Crit'Air"), AgGridService.group("Equipements", [AgGridService.text("ndEquipment", "Nb", 100), AgGridService.bool("parkingAidRear", "Radar de recul", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("parkingAidFront", "Radar avant", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("cameraRear", "Caméra de recul", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("cameraFront", "Caméra avant", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("cruiseControl", "Régulateur de vitesse", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("limitControl", "Régulateur de vitesse", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("adaptiveCruiseControl", "ACC", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("laneDepartureWarning", "LDW", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("airConditioning", "Climatisation", 100, {
        columnGroupShow: "open"
      }), AgGridService.bool("gps", "GPS", 100, { columnGroupShow: "open" }), AgGridService.bool("allSeasonTire", "Pneus 4 saisons", 100, {
        columnGroupShow: "open"
      }), AgGridService.date("allSeasonTireLastDate", "Date montage Pneus 4 saisons", 100, { columnGroupShow: "open" }), AgGridService.bool("winterTire", "Pneus hiver", 100, {
        columnGroupShow: "open"
      }), AgGridService.date("winterTireLastDate", "Date montage Pneus hiver", 100, { columnGroupShow: "open" })]), AgGridService.date("inDate", "Date d'entrée"), AgGridService.date("outDate", "Date de sortie"), AgGridService.date("creationDate", "Date de création"), AgGridService.date("lastUserModificationDate", "Date de modification"), AgGridService.date("importDate", "Date d'import"), AgGridService.text("importByName", "Importé par"), AgGridService.date("updateDate", "Mis à jour le"), AgGridService.text("updateBy", "Mis à jour par")];

      vm.delete = function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
          var deleteVehicle;
          return regeneratorRuntime.wrap(function _callee5$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return swal({
                    title: "Voulez-vous supprimer le v\xE9hicule " + row.plateNumber + " ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteVehicle = _context6.sent;

                  if (!deleteVehicle) {
                    _context6.next = 7;
                    break;
                  }

                  console.log("need to delete this vehicle", row);
                  _context6.next = 7;
                  return VehiclesService.deleteById(row._id).then(function () {
                    Notiflix.Notify.success("La suppression a réussi");
                    vm.refresh();
                  });

                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee5, _this2);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }();

      vm.columnDefs.unshift(AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, _this2, {
        width: 110
      }));

      if (writeResource || deleteResource) {
        var adminColumns = [];

        if (writeResource) {
          adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, _this2, {
            width: 90
          }));
        }
        if (deleteResource && writeResource) {
          adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this2, {
            width: 90,
            columnGroupShow: "open"
          }));
        } else if (deleteResource) {
          adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this2, {
            width: 90
          }));
        }
        var adminGroup = AgGridService.group("Admin", adminColumns);
        vm.columnDefs.unshift(adminGroup);
      }

      if (["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false) {
        vm.columnDefs.unshift(AgGridService.checkbox());
      }
    };
  }
})();